<div class="modal-header border-0 px-lg-5 px-2">
	<span class="modal-title theme-main-color fs-4 fw-bold ms-2 mt-3"
		>Ajout</span
	>
	<button
		type="button"
		class="btn-close"
		data-bs-dismiss="modal"
		aria-label="Close"
		(click)="bsModalRef.hide()"
	></button>
</div>

<div class="modal-body">
	<div class="row px-lg-5 px-2">
		<div class="">
			<div class="row">
				<span class="theme-main-color fs-4 col">Informations</span>
			</div>
			<div class="row my-2">
				<form id="formEdit" [formGroup]="formEdit" (ngSubmit)="onSubmit()">
					<div class="row my-4">
						<label for="name" class="form-label theme-main-color fw-bold"
							>Nom</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="name"
							name="name"
							formControlName="name"
							[ngClass]="{
								'is-invalid': name.invalid,
								'is-valid': name.dirty && name.valid
							}"
						/>
					</div>
					<div class="row my-4">
						<label for="responsable" class="form-label theme-main-color fw-bold"
							>Responsable</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="responsable"
							name="responsable"
							formControlName="responsable"
							[ngClass]="{
								'is-invalid': responsable.invalid,
								'is-valid': responsable.dirty && responsable.valid
							}"
						/>
					</div>

					<div class="row my-4">
						<label for="mailDiffusion" class="form-label theme-main-color fw-bold"
							>Mail du(des) responsable(s)</label
						>
						<input
							autocomplete="off"
							type="text"
							class="form-control"
							id="mailDiffusion"
							name="mailDiffusion"
							formControlName="mailDiffusion"
						/>
					</div>

					<div class="row my-4">
							<label for="typeHandicap" class="form-label fw-bold"
								>Type de handicap</label
							>
							<select
								id="typeHandicap"
								class="form-select"
								name="typeHandicap"
								formControlName="typeHandicap"
								aria-label="Sélectionner un type"
								>
								<option *ngFor="let typeHandicap of listTypeHandicap" value="{{ typeHandicap.id }}">
									{{ typeHandicap.name}}
								</option>
							</select>
					</div>

					<div class="row my-4">
						<div class="form-check form-switch ms-2">
							<input
								class="form-check-input theme-main-border-color"
								type="checkbox"
								id="cotraitant"
								formControlName="cotraitant"
								[ngClass]="{
									'theme-main-color-check': cotraitant.value
								}"
							/>
							<label class="form-check-label text-dark" for="cotraitant"
								>Co-traitant</label
							>
						</div>
					</div>

					<div class="row my-4">
						<div class="form-check form-switch ms-2">
							<input
								class="form-check-input theme-main-border-color"
								type="checkbox"
								id="handleInfosas"
								formControlName="handleInfosas"
								[ngClass]="{
									'theme-main-color-check': handleInfosas.value
								}"
							/>
							<label class="form-check-label text-dark" for="handleInfosas"
								>Gère INFOSAS</label
							>
						</div>
					</div>

					<div class="row my-4">
						<div class="col-12 col-lg">
							<label for="region" class="form-label fw-bold">Régions</label>
							<div class="row">
								<div
									class="col-md-4 check"
									*ngFor="let region of listRegion | orderBy : 'name' : 'asc'"
								>
								<div *ngIf="region.id !== 0">
									<input
										type="checkbox"
										name="{{ region.id }}"
										class="form-check-input"
										[value]="region"
										[checked]="isRegionCheck(region)"
										[ngClass]="{
											'theme-main-color-check': isRegionCheck(region)
										}"
										(change)="updateSelectedRegion($event, region)"
									/>
									<label class="ms-2 form-check-label text-dark">
										{{ region.name }}
									</label>
								</div>
							</div>
							</div>
						</div>
					</div>

					<div class="row my-4">
						<div class="col-12 col-lg">
							<label class="form-label fw-bold">Expertises</label>
							<accordion style="border:none;">
								<accordion-group heading="Qualification" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseQD of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseQD.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseQD.id }}"
													class="form-check-input"
													[value]="expertiseQD"
													[checked]="isExpertiseQDCheck(expertiseQD)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseQDCheck(expertiseQD)
													}"
													(change)="updateSelectedExpertiseQD($event, expertiseQD)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseQD.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
								<accordion-group heading="AS" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseAS of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseAS.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseAS.id }}"
													class="form-check-input"
													[value]="expertiseAS"
													[checked]="isExpertiseASCheck(expertiseAS)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseASCheck(expertiseAS)
													}"
													(change)="updateSelectedExpertiseAS($event, expertiseAS)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseAS.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
								<accordion-group heading="AC" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseAC of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseAC.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseAC.id }}"
													class="form-check-input"
													[value]="expertiseAC"
													[checked]="isExpertiseACCheck(expertiseAC)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseASCheck(expertiseAC)
													}"
													(change)="updateSelectedExpertiseAC($event, expertiseAC)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseAC.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
								<accordion-group heading="EAP" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseEAP of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseEAP.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseEAP.id }}"
													class="form-check-input"
													[value]="expertiseEAP"
													[checked]="isExpertiseEAPCheck(expertiseEAP)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseEAPCheck(expertiseEAP)
													}"
													(change)="updateSelectedExpertiseEAP($event, expertiseEAP)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseEAP.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
								<accordion-group heading="CAMEO" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseCAMEO of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseCAMEO.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseCAMEO.id }}"
													class="form-check-input"
													[value]="expertiseCAMEO"
													[checked]="isExpertiseCAMEOCheck(expertiseCAMEO)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseCAMEOCheck(expertiseCAMEO)
													}"
													(change)="updateSelectedExpertiseCAMEO($event, expertiseCAMEO)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseCAMEO.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
								<accordion-group heading="SUIVI" [isOpen]="true" style="font-size: small;">
									<div class="row">
										<div
											class="col-md-4 check"
											*ngFor="let expertiseSUIVI of listExpertise | orderBy : 'name' : 'asc'"
										>
											<div *ngIf="expertiseSUIVI.id !== 0">
												<input
													type="checkbox"
													name="{{ expertiseSUIVI.id }}"
													class="form-check-input"
													[value]="expertiseSUIVI"
													[checked]="isExpertiseSUIVICheck(expertiseSUIVI)"
													[ngClass]="{
														'theme-main-color-check': isExpertiseSUIVICheck(expertiseSUIVI)
													}"
													(change)="updateSelectedExpertiseSUIVI($event, expertiseSUIVI)"
												/>
												<label class="ms-2 form-check-label text-dark">
													{{ expertiseSUIVI.name }}
												</label>
											</div>
										</div>
									</div>
								</accordion-group>
							</accordion>
						</div>
					</div>

					<div class="row my-5">
						<div class="d-flex justify-content-end">
							<button
								class="btn theme-main-color-button mx-3 px-3"
								type="button"
								(click)="bsModalRef.hide()"
							>
								Retour
							</button>
							<button
								[disabled]="!formEdit.valid || isValidateButtonClicked"
								class="btn theme-green-button"
								type="submit"
								form="formEdit"
							>
								<i class="bi bi-save-fill px-1" aria-hidden="true"></i
								>Sauvegarder
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
